const SetUnsetDeletedListTable = (listTables)=>{
    let NewListTable = [];
    // console.log('будет пиздеть потому что тут это ',listTables);
    const sourceList = Array.isArray(listTables)
        ? listTables
        : (
            Array.isArray(listTables?.data)
                ? listTables.data
                : (
                    Array.isArray(listTables?.promocode_list)
                        ? listTables.promocode_list
                        : (
                            Array.isArray(listTables?.promoCreateList)
                                ? listTables.promoCreateList
                                : (
                                    Array.isArray(listTables?.promoCreateList?.promocode_list)
                                        ? listTables.promoCreateList.promocode_list
                                        : []
                                )
                        )
                )
        );

    if(!sourceList || sourceList === undefined){
        return [];
    }else {
        sourceList.forEach((d, n) => {
                if (d.deleted === "0" || d.deleted === false || !d.deleted) {
                    NewListTable.push(d)
                } else {

                }
            }
        );
        return NewListTable;
    }
};

export default SetUnsetDeletedListTable
